import { Controller } from "@hotwired/stimulus";

import ImpairedPanel from "../impaired/panel.svelte";

// Connects to data-controller="header-menu"
export default class extends Controller {
  static targets = ["nav", "menuIcon", "crossIcon", "navItem", "search"];

  connect() {
    console.log("HeaderMenuController connected");
    console.log("Controller element:", this.element);
    console.log("Menu toggle button:", this.element.querySelector(".menu-toggle"));
    
    // Привязываем обработчик resize
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
    
    this.setupMenuItems();
    this.addImpairedPanel();
    
    // Проверяем, что кнопка меню существует и видима
    const menuToggle = this.element.querySelector(".menu-toggle");
    if (menuToggle) {
      console.log("Menu toggle found:", menuToggle);
      console.log("Menu toggle visible:", window.getComputedStyle(menuToggle).display !== "none");
      console.log("Menu toggle pointer-events:", window.getComputedStyle(menuToggle).pointerEvents);
      
      // Добавляем прямой обработчик как fallback
      menuToggle.addEventListener("click", (e) => {
        console.log("Direct event listener fired");
        this.toggleMenu(e);
      });
    } else {
      console.warn("Menu toggle button not found!");
    }
  }

  toggleMenu(event) {
    console.log("toggleMenu clicked", event);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Используем targets если они есть, иначе fallback на querySelector
    const nav = this.hasNavTarget ? this.navTarget : this.element.querySelector(".nav");
    const menuIcon = this.hasMenuIconTarget ? this.menuIconTarget : this.element.querySelector(".menu-icon");
    const crossIcon = this.hasCrossIconTarget ? this.crossIconTarget : this.element.querySelector(".cross-icon");

    console.log("Elements found:", { nav, menuIcon, crossIcon });

    if (nav) {
      nav.classList.toggle("active");
      console.log("Nav active:", nav.classList.contains("active"));
    }
    if (menuIcon) {
      menuIcon.classList.toggle("hidden");
      console.log("MenuIcon hidden:", menuIcon.classList.contains("hidden"));
    }
    if (crossIcon) {
      crossIcon.classList.toggle("hidden");
      console.log("CrossIcon hidden:", crossIcon.classList.contains("hidden"));
    }
  }

  handleSearchClick() {
    const search = this.element.querySelector(".header__search");
    search.classList.toggle("active");
  }

  handleSightClick(ev) {
    ev.preventDefault();
    this.impairedPanel.toggleState();
  }

  handleNavItemClick(event) {
    if (window.innerWidth < 1025) {
      const navItem = event.currentTarget;
      const allNavItems = this.element.querySelectorAll(".nav__item");

      allNavItems.forEach((item) => {
        if (item !== navItem && item.classList.contains("expanded")) {
          item.classList.remove("expanded");
        }
      });

      navItem.classList.toggle("expanded");
    }
  }

  addImpairedPanel() {
    const language = document.querySelector("html").lang;
    const page = document.querySelector("#page");
    const target = document.querySelector("#impaired-panel");

    this.impairedPanel = new ImpairedPanel({target, props: {language, page}});
  }

  setupMenuItems() {
    const navItems = this.element.querySelectorAll(".nav__item");

    navItems.forEach((navItem) => {
      const newNavItem = navItem.cloneNode(true);
      navItem.parentNode.replaceChild(newNavItem, navItem);
    });
  }

  handleResize() {
    if (window.innerWidth >= 1025) {
      const nav = this.element.querySelector(".nav");
      const menuIcon = this.element.querySelector(".menu-icon");
      const crossIcon = this.element.querySelector(".cross-icon");
      const navItems = this.element.querySelectorAll(".nav__item");

      if (nav) nav.classList.remove("active");
      if (menuIcon) menuIcon.classList.remove("hidden");
      if (crossIcon) crossIcon.classList.add("hidden");

      navItems.forEach((item) => {
        item.classList.remove("expanded");
      });
    }
  }

  disconnect() {
    if (this.boundHandleResize) {
      window.removeEventListener("resize", this.boundHandleResize);
    }
  }
}
